'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
function readResponseText(request) {
    try {
        return request.responseText || null;
    } catch (error) {
        // Browsers throw when reading responseText if responseType is not '' or 'text'.
        return null;
    }
}

function getResponseText(error) {
    if (error.response && error.response.request) {
        var responseText = readResponseText(error.response.request);

        if (responseText) {
            return responseText;
        }
    }

    if (error.request) {
        return readResponseText(error.request);
    }

    return null;
}

function getErrorMessage(error) {
    if (!error) {
        return '';
    }

    if (typeof error === 'string') {
        return error;
    }

    if (error.response && error.response.data) {
        if (typeof error.response.data === 'string') {
            return error.response.data;
        }

        if (error.response.data.detail) {
            return error.response.data.detail;
        }

        if (error.response.data.message) {
            return error.response.data.message;
        }

        if (error.response.data.error) {
            return error.response.data.error;
        }
    }

    var responseText = getResponseText(error);

    if (responseText) {
        return responseText;
    }

    return error.message || String(error);
}

exports.getErrorMessage = getErrorMessage;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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


//////////////////
// WEBPACK FOOTER
// ./src/client/utils/errors.js
// module id = 584
// module chunks = 0